import React from "react";
import { ChevronRight } from "lucide-react";
import type { DtoAdminSearchBorrowerApplication } from "@porchpass/api-client";
import {
  applicationAddress,
  applicationDisplayName,
  applicationExternalId,
  applicationPhone,
  applicationStatus,
} from "src/api/preApproval/mappers";

interface BorrowerResultListProps {
  results: DtoAdminSearchBorrowerApplication[];
  onOpenWorkspace: (borrower: DtoAdminSearchBorrowerApplication) => void;
}

export function BorrowerResultList({
  results,
  onOpenWorkspace,
}: BorrowerResultListProps) {
  return (
    <div className="flex w-full flex-col gap-4">
      {results.map((borrower) => {
        const externalId = applicationExternalId(borrower);
        if (!externalId) {
          return null;
        }

        return (
          <button
            key={externalId}
            type="button"
            onClick={() => onOpenWorkspace(borrower)}
            className="flex w-full items-center justify-between gap-4 rounded-xl border border-[#E4E7EC] bg-white px-4 py-3.5 text-left transition-colors hover:border-[#3265EA] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1453F5]/30"
          >
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-[15px] leading-tight text-[#101827]">
                {applicationDisplayName(borrower)}
              </p>
              <p className="mt-1 text-xs leading-tight text-[#697083] truncate">
                {applicationStatus(borrower)} · {applicationAddress(borrower)} ·{" "}
                {applicationPhone(borrower)}
              </p>
            </div>
            <ChevronRight className="h-[18px] w-[18px] shrink-0 text-[#9CA3AF]" />
          </button>
        );
      })}
    </div>
  );
}
